module.exports = __webpack_public_path__ + "img/Drop.8624305c.webp";